import { render, staticRenderFns } from "./commonTextarea.vue?vue&type=template&id=688e098b"
import script from "./commonTextarea.vue?vue&type=script&lang=js"
export * from "./commonTextarea.vue?vue&type=script&lang=js"
import style0 from "./commonTextarea.vue?vue&type=style&index=0&id=688e098b&prod&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports